import { GUESTPRO_URL, waLink, WA_DEFAULT_MSG } from "@/lib/site";

const ContactCta = () => (
  <section id="contact" className="py-24 bg-ocean-900 text-white" data-testid="contact-section">
    <div className="max-w-5xl mx-auto px-6 text-center">
      <span className="text-xs font-mono-clean text-terracotta uppercase tracking-widest font-semibold">
        Reserve Your Stay
      </span>
      <h2 className="font-display text-4xl sm:text-5xl font-bold mt-3 text-white">
        Book direct with Raffiel Nias
      </h2>
      <p className="text-sm text-sand-50/80 mt-4 max-w-xl mx-auto">
        Direct rates starting from $45/night with instant confirmation via
        GuestPro or personalized assistance on WhatsApp.
      </p>
      <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
        <a
          href={GUESTPRO_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-guestpro-button"
          className="w-full sm:w-auto px-8 py-4 rounded-xl font-bold text-sm text-ocean-900 bg-sand-50 hover:bg-white shadow-xl transition-colors"
        >
          Book Online with GuestPro
        </a>
        <a
          href={waLink(WA_DEFAULT_MSG)}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="contact-whatsapp-button"
          className="w-full sm:w-auto px-8 py-4 rounded-xl font-bold text-sm text-white bg-ocean-700 hover:bg-ocean-600 shadow-xl transition-colors"
        >
          Chat on WhatsApp
        </a>
      </div>
      <p className="text-xs text-sand-50/60 mt-4 font-mono-clean">
        Free cancellation windows available · No hidden fees
      </p>
    </div>
  </section>
);

export default ContactCta;
